import {Vue, Component} from 'vue-property-decorator';

@Component({
    name: 'search-box',
})
export default class SearchBox extends Vue {

    onClickSearch(){
        this.$emit('search');
    }
}